
import { createRoot } from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.css";

import "bootstrap/dist/js/bootstrap.bundle";
import 'bootstrap-icons/font/bootstrap-icons.css';
import reportWebVitals from './reportWebVitals';
import App from './App';


createRoot(document.getElementById('root')).render(
    <App/>
);

reportWebVitals();
